import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import {Message} from 'iview';
import router from '../router'
import Vuex from 'vuex'
import store from '../store/store'

const axiosIns = axios.create()
if (process.env.NODE_ENV == 'development') { //本地环境
	axiosIns.defaults.baseURL = 'http://www.zccms.com/';
} else if (process.env.NODE_ENV == 'debug') { //调试环境
	axiosIns.defaults.baseURL = 'http://192.168.2.53:30/';
} else if (process.env.NODE_ENV == 'production') { // 线上环境
	axiosIns.defaults.baseURL = 'https://aapi.ahsjsd.com/'; //线上
	// axiosIns.defaults.baseURL = 'https://zapi.ahsjsd.com/'; //线上测试
	// axiosIns.defaults.baseURL = 'https://hapi.ahsjsd.com/'; //线上测试
}
axiosIns.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
axiosIns.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
axiosIns.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest';
axiosIns.defaults.responseType = 'json';
axiosIns.defaults.timeout = 600000
axiosIns.defaults.validateStatus = function (status) {
	return true;
};
axiosIns.defaults.transformRequest = [
	function (data) {
		return qs.stringify(data);
	}
];
axiosIns.defaults.validateStatus = function (status) {
	return true;
};
// 添加请求拦截器
axiosIns.interceptors.request.use(function (config) {
	let token = store.state.token;
	if (token && token !== 'undefined') config.headers['token'] = token
	return config
}, function (error) {
	Message.error({ background: true, content: '错误的传参' });
	return Promise.reject(error)
})

axiosIns.interceptors.response.use((res) => {
	if (!res.data) {
		return Promise.reject(res)
	}
	return res
}, (error) => {
	return Promise.reject(error)
})
const ajaxMethod = ['get', 'post']
const api = {}
ajaxMethod.forEach((method) => {
	api[method] = function (uri, data, config) {
		return new Promise(function (resolve, reject) {
			axiosIns[method](uri, data, config).then((response) => {
				if (response.data.code === 10000001) {
					window.localStorage.removeItem('token');
					window.localStorage.removeItem('userinfo');
					window.localStorage.removeItem('menu_id');
					store.commit('SET_TOKEN' , '');
					store.commit('SET_USERINFO' , []);
					store.commit('SET_MENU_ID' , '');
					router.push({
						path: "/login",
					});
				}else if (response.data.code === 10000002) {
					Message.error({ background: true, content: response.data.msg });
					router.push({
						path: "/index",
					});
				}else if (response.data.code === 0 || response.data.code === 1 || response.data.code === 10000000) {
					resolve(response.data)
				}
			}).catch(function (error) {
				if (error.response) {
					Message.error({ background: true, content: '服务器无响应' });
				} else {
					Message.error({ background: true, content: '网络故障' });
				}
			})
		})
	}
})

/**
 * 导出Excel（后端生成文件并返回 {code:0, data:'/upload/xxx.xlsx', msg:'导出成功'}）
 * @param {String} uri      接口地址，如 '/admin/order/export'
 * @param {Object} data     请求参数（POST，form-urlencoded，同 post 方法）
 * @param {String} filename 下载后的文件名（可选，默认取服务器文件名）
 * 用法：this.$axios.downloadExcel('/admin/order/export', { search: this.search }, '订单列表.xlsx')
 */
api.downloadExcel = function (uri, data, filename) {
	data = data || {};
	return new Promise(function (resolve, reject) {
		api.post(uri, data).then(function (res) {
			if(res.code === 10000000){
				Message.error({ background: true, duration:3, content: res.msg });
				return;
			}

			let fileUrl = res.data;
			if (!fileUrl) {
				Message.error({ background: true, content: res.msg || '导出失败' });
				reject(res);
				return;
			}
			// 相对路径补全为完整 URL
			let base = axiosIns.defaults.baseURL || '';
			if (fileUrl.indexOf('http') !== 0) {
				fileUrl = (base.replace(/\/+$/, '') + '/' + fileUrl.replace(/^\/+/, ''));
			}
			// 未指定文件名时取 URL 中的文件名
			if (!filename) {
				filename = fileUrl.split('/').pop().split('?')[0] || '导出数据.xlsx';
			}
			let link = document.createElement('a');
			link.href = fileUrl;
			link.download = filename;
			link.target = '_blank';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			resolve(res);
		}).catch(function (error) {
			reject(error);
		});
	});
};
export default api



// WEBPACK FOOTER //
// ./src/utils/http.js